'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (feis_id) {
  return function (dispatch) {
    dispatch({
      feis_id: feis_id,
      type: 'SET_SELECTED_DASHBOARD_FEIS'
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/feiseanna/setSelectedFeis.js
// module id = 653
// module chunks = 0